export default {
    LOAD_PRODUCTS (state, products) {
        state.items = products
    },
    LOAD_PRODUCT (state, products) {
        state.item = products
    }
}